import script from "./PianificazioneRealeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PianificazioneRealeDialog.vue?vue&type=script&setup=true&lang=js"

import "./PianificazioneRealeDialog.vue?vue&type=style&index=0&id=4b040448&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b040448"]])

export default __exports__